import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Resolve } from '@angular/router';
import 'rxjs';

import { GlobalConstants } from '../common/global-constants';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { makeStateKey, Meta, TransferState } from '@angular/platform-browser';
import ILayout from '../models/layout';
import { GTMScriptService } from '../services/gtm-script.service';

// Page
export interface PageResponse {
  status: boolean;
  message: string;
  redirect: string;
  page_info: PageInfo;
  data: any[];
  popup: Popup;
}

export interface PageInfo {
  id: number;
  url: string;
  slug: string;
  title: string;
  metaTitle: string;
  image: string;
  description: string;
  lang: string;
  otherlangs: { string: string };
}

export interface Popup {
  id: number;
  status: boolean;
  is_global: boolean;
  is_video: boolean;
  image: string;
  image_mobile: string;
  video_url: string;
  link: string;
  title: string;
  content: string;
  show_once: boolean;
  buttons: any[];
}

@Injectable()
export class RouteResolver implements Resolve<any> {
  public isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) platformId: any,
    private meta: Meta,
    public http: HttpClient,
    private readonly transferState: TransferState,
    private gtmService: GTMScriptService
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.meta.addTags([
      { name: 'og:title', content: '' },
      { name: 'og:description', content: '' },
      { name: 'og:url', content: '' },
      { name: 'og:image', content: '' },
      { name: 'twitter:card', content: '' },
      { name: 'twitter:site', content: '' },
      { name: 'twitter:title', content: '' },
      { name: 'twitter:description', content: '' },
      { name: 'twitter:image', content: '' },
      { name: 'twitter:url', content: '' },
    ]);
  }

  resolve(data: any): Observable<any> {
    const nPage = {
      layout: {},
      pageContent: {},
      popup: {},
    };

    //soru işareti ve #işaretlerini görmezden geliyoruz
    let url = data._routerState.url;
    url = url.split('#')[0];
    url = url.split('?')[0];

    var apiUrl = GlobalConstants.apiURL;

    //ssr ile local çekim yapılırken 80 portunu kullanıyoruz.
    if (!this.isBrowser) {
      apiUrl = apiUrl.replace('https', 'http');
    }

    if (this.isBrowser && url == '/mobil') {
      if (
        /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        if (
          /HMSCore/i.test(navigator.userAgent) &&
          !/GMS/i.test(navigator.userAgent)
        ) {
          window.location.assign(
            'https://appgallery.huawei.com/#/app/C101565365'
          );
        } else {
          window.location.assign(
            'https://play.google.com/store/apps/details?id=com.aktifbank.nkolay'
          );
        }
      } else if (/iPhone|iPad|iPod|/i.test(navigator.userAgent)) {
        window.location.assign(
          'https://apps.apple.com/tr/app/n-kolay/id1449491530?l=tr'
        );
      } else {
        window.location.assign('/');
      }
    }

    const lang = url.startsWith('/en/') || url === '/en' ? 'en' : 'tr';
    GlobalConstants.lang = lang;

    //anasayfa / ile çekiliyor replace ediyoruz
    if (url == "/") {
      url = lang == "en" ? "/en/homepage" : "/anasayfa";
    }

    //random değer ile olası cache i önlüyoruz
    url = apiUrl + '/page?url=' + url;

    const reqHeader = new HttpHeaders({ 'Content-Type': 'application/json' });
    return new Observable((observer) => {
      const key = makeStateKey(url.replace(apiUrl, ""));
      if (this.transferState.hasKey(key)) {
        const pageData = this.transferState.get<{
          layout: any,
          pageContent: any,
          popup: any,
        } | null>(key, null);
        if(pageData != null)
        {
          GlobalConstants.layout =  pageData.layout;
          GlobalConstants.activePage = pageData.pageContent;
  
          if (data.popup && data.popup.status && data.popup.is_global) {
            GlobalConstants.popup = data.popup;
            nPage.popup = data.popup;
          } else if (pageData.popup && pageData.popup.status) {
            GlobalConstants.popup = pageData.popup;
            nPage.popup = pageData.popup;
          }
  
          observer.next(pageData);
          observer.complete();
        }
      } else {
        this.http
          .get(url, {
            headers: reqHeader,
          })
          .subscribe((response: any) => {
            this.http
              .get(apiUrl + '/layout?lang=' + lang)
              .subscribe((data: any) => {
                nPage.pageContent = response;
                nPage.layout = data;
                GlobalConstants.layout = data;
                GlobalConstants.activePage = response;

                if (data.popup && data.popup.status && data.popup.is_global) {
                  GlobalConstants.popup = data.popup;
                  nPage.popup = data.popup;
                } else if (response.popup && response.popup.status) {
                  GlobalConstants.popup = response.popup;
                  nPage.popup = response.popup;
                }

                this.transferState.set(key, (nPage as any));

                observer.next(nPage);
                observer.complete();
              });
          });
      }
      if (data._routerState.url === '/') {
        this.gtmService.pushMultipleStructured([
          {
            '@type': 'BankOrCreditUnion',
            '@context': 'https://schema.org',
            name: 'Aktif Bank',
            legalname: 'Aktif Yatırım Bank A.Ş.',
            url: 'https://www.aktifbank.com.tr',
            logo: 'https://www.aktifbank.com.tr/assets/images/svg/logo.svg',
            telephone: '08507243050',
            image: 'https://www.aktifbank.com.tr/assets/images/svg/logo.svg',
            contactPoint: [
              {
                '@type': 'ContactPoint',
                telephone: '08507243050',
                contactType: 'customer service',
              },
            ],
            address: {
              '@type': 'PostalAddress',
              addressLocality: 'İstanbul',
              addressRegion: 'TR',
              streetAddress:
                'Aktif Bank Genel Müdürlük, Esentepe Mahallesi, Kore Şehitleri Caddesi No: 8/1 Şişli / İstanbul',
              postalCode: '34394',
            },
            '@id': 'https://www.aktifbank.com.tr',
            potentialAction: [
              {
                '@type': 'SearchAction',
                target: 'https://www.aktifbank.com.tr/search?q={search_term_string}',
                'query-input': 'required name=search_term_string',
              },
            ],
            sameAs: [
              'https://www.linkedin.com/company/aktif-bank',
              'https://www.youtube.com/user/AktifBank',
            ],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            '@id': 'https://www.aktifbank.com.tr/#website',
            url: 'https://www.aktifbank.com.tr/',
            name: 'Aktif Bank',
            inLanguage: 'tr-TR',
            description: "Türkiye'nin en büyük özel sermayeli yatırım bankası.",
            publisher: {
              '@type': 'Organization',
              name: 'Aktif Bank',
              url: 'https://www.aktifbank.com.tr/',
            },
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.aktifbank.com.tr/arama?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          },
        ]);
      } 
      else if (data._routerState.url === '/hakkimizda/bize-ulasin/sikca-sorulan-sorular/alternatif-guvenlik-sorusu') {
        this.gtmService.pushStructured({
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
                    "@type": "Question",
                    "name": "Alternatif güvenlik sorum bloke olduğunda ne yapmam gerekiyor?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Alternatif Güvenlik Sorunuz bloke olduğunda, bloke kaldırma dilekçenizi İletişim Formu adresindeki başvuru adımlarını takip ederek bizlere ulaştırmanız gerekmektedir. Dilekçe örneği için tıklayınız. Dilekçeniz olumlu değerlendirildikten sonra sistemde kayıtlı GSM numaranıza geçici İnternet Şube/N Kolay Mobil şifreniz gönderilecektir. Bu şifre ile giriş yaptıktan sonra ek güvenlik adımını geçerek yeni alternatif güvenlik sorunuzu ve cevabınızı belirleyerek blokenizin kalkmasını sağlayabilirsiniz."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Alternatif güvenlik sorumu nasıl oluşturabilirim?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Alternatif Güvenlik Sorunuzu ve Cevabınızı daha önce belirlemediyseniz İnternet Şube veya N Kolay Mobil uygulamasına ilk girişiniz sonrasında karşınıza çıkacak ekrandan belirleyebilirsiniz. ​"
                    }
                },
                {
                    "@type": "Question",
                    "name": "Alternatif güvenlik sorumu nasıl, nereden değiştirebilirim?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Alternatif Güvenlik Sorunuzu İnternet Şube'ye giriş yaptıktan sonra Diğer >  Bilgi Güncelleme > Alternatif Güvenlik Sorusu ve Cevabını Değiştirme menüsünden mevcut sorunuzun cevabını girdikten sonra yeni sorunuzu ve cevabını belirleyebilirsiniz. Alternatif Güvenlik Sorunuzu N Kolay Mobil uygulamasına giriş yaptıktan sonra Profil >  Ayarlar > Güvenlik Sorusu Güncelleme menüsünden mevcut sorunuzun cevabını girdikten sonra yeni sorunuzu ve cevabını belirleyebilirsiniz."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Alternatif güvenlik sorusu ve cevabı nedir?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "İnternet Şube ve N Kolay Mobil uygulama şifrenizi oluştururken veya şifrenizi unuttuğunuzda belirlemiş olduğunuz Alternatif Güvenlik Sorunuzun cevabını doğrulayarak yeni şifrenizi oluşturabilirsiniz."
                    }
                }
            ]
        });
    }    
      else {
        this.gtmService.removeStructured();
      }
    }
    );
  }
}
